/**
 * Notion Golf — relocate the Mageplaza/Avada "Size chart" inline block so it sits
 * inline with the Size variant-option header (right-aligned). Keeps the app block
 * intact (the modal still works) and self-heals if the product section re-renders.
 */
(function () {
  const BLOCK = '[id*="mageplaza_size_chart"], .shopify-app-block.mp-inline-button';

  function sizeLegend() {
    const picker =
      document.querySelector('.product-details .variant-picker') ||
      document.querySelector('.variant-picker');
    if (!picker) return null;
    const options = picker.querySelectorAll('.variant-option');
    if (!options.length) return null;
    for (const option of options) {
      const legend = option.querySelector('legend');
      if (legend && /size/i.test(legend.textContent)) return legend;
    }
    // Fallback: last option (size is typically last)
    return options[options.length - 1].querySelector('legend');
  }

  // Keeps the relocated node alive while it is detached. Changing a variant makes
  // Horizon morph .product-details in place; the morph reconciles the variant picker
  // against server markup that has no size-chart child and deletes the node we moved
  // in, and it does not repopulate app-block subtrees, so nothing puts it back. Held
  // here, the element survives (with its listeners) and can simply be re-attached.
  let saved = null;

  function relocate() {
    // Prefer a block that is actually in the document; fall back to the saved node.
    const live = document.querySelector(BLOCK);
    const block = live || saved;
    if (!block) return;

    // If the app ever does render a fresh copy, drop any stale duplicates.
    if (live) {
      for (const extra of document.querySelectorAll(BLOCK)) {
        if (extra !== live) extra.remove();
      }
    }
    saved = block;

    const legend = sizeLegend();
    if (!legend || block.parentElement === legend) return;

    const originalParent = block.parentElement;
    legend.classList.add('notion-size-legend');
    legend.appendChild(block);

    // Hide the now-empty original slot so it doesn't leave a gap in the column.
    if (originalParent && originalParent !== legend && originalParent.children.length === 0) {
      originalParent.style.display = 'none';
    }
  }

  function boot() {
    relocate();

    // Deliberately a timeout rather than requestAnimationFrame: rAF is starved while
    // the tab is hidden, which would leave `scheduled` latched on and the button
    // permanently missing for anyone who switches tabs mid-variant-change.
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        relocate();
      }, 0);
    };

    // Observe the section rather than .product-details: the latter is the element the
    // variant re-render rewrites, so an observer bound to it can end up watching a
    // node that is no longer the live one.
    const scope = document.querySelector('.product-information') || document.body;
    new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });

    // Belt and braces — the semantic signal for a variant re-render.
    document.addEventListener('variant:update', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
